var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-bayes-page" },
    [
      _c(
        "div",
        { staticClass: "total_bay_item" },
        [
          _c("div", { staticClass: "quick_panel" }, [
            _c(
              "button",
              {
                attrs: { title: "后验概率全计算" },
                on: {
                  click: function($event) {
                    return _vm.calc_a("all")
                  }
                }
              },
              [_vm._v("全部概率计算")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "自动把A事件的概率数值归一化" },
                on: { click: _vm.PA_normalize }
              },
              [_vm._v("事件A归一化")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.last_PA.length > 0,
                    expression: "last_PA.length>0"
                  }
                ],
                attrs: { title: "撤销事件A数值归一化,如果已经修改不可撤销" },
                on: { click: _vm.cancel_PA_normalize }
              },
              [_vm._v("撤销归一化")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "自动补齐对立事件或者新建事件" },
                on: { click: _vm.auto_add_item }
              },
              [_vm._v("智能添加事件")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "事件重复进行" },
                on: { click: _vm.repeat_event }
              },
              [_vm._v("事件重复")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "自定义事件" },
                on: { click: _vm.custom_event }
              },
              [_vm._v("自定义事件")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "隐藏边栏" },
                on: {
                  click: function($event) {
                    return _vm.$emit("toggle_panel")
                  }
                }
              },
              [_vm._v("隐藏侧边栏")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "quick_panel2" }, [
            _c(
              "button",
              {
                attrs: { title: "案例说明" },
                on: { click: _vm.case_introduce }
              },
              [_vm._v(" 案例引入")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { attrs: { title: "学习视频" }, on: { click: _vm.case_video } },
              [_vm._v(" 视频学习")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                attrs: { title: "对学习使用过程进行反馈" },
                on: { click: _vm.my_think }
              },
              [_vm._v("我的反思")]
            )
          ]),
          _vm._v(" "),
          _c("bay-item-info", {
            attrs: { event_info: _vm.event_info, sample_list: _vm.sample_list },
            on: { sample_change: _vm.sample_change }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "bay-item-card-list" }, [
            _c(
              "div",
              { staticClass: "content-wrapper" },
              _vm._l(_vm.items, function(item, idx) {
                return _c("bay-item", {
                  key: idx,
                  attrs: {
                    bay_item: item,
                    event_info: _vm.event_info,
                    is_bi: _vm.is_bi(_vm.items, idx),
                    index: idx,
                    editable: idx == _vm.items.length - 1
                  },
                  on: {
                    add_item: _vm.add_item,
                    remove_item: _vm.remove_item,
                    update_data: _vm.has_update,
                    calc_pa: _vm.calc_pa,
                    "help-msg": _vm.help_msg
                  }
                })
              }),
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("bay-item-footer", {
        attrs: {
          content: _vm.create_calc_eq,
          value: _vm.PB_result,
          title: _vm.PB_info
        },
        on: {
          calc_PB: function($event) {
            return _vm.calc_a("no_pb")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }